import React from 'react';
import pluralize from 'pluralize';

// material ui
import CheckIcon from '@material-ui/icons/CheckCircle';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { BaseWidget, styles } from './widgets/baseWidget';

const notificationStyles = {
  base: {
    marginRight: '10px',
    height: '14px',
    width: '14px'
  },
  green: { color: '#009E73' }
};

const TenantsDetails = (props) => {
  const header = () => {
    if (!props.totalTenants) {
      return null;
    } else {
      let notificationSymbol = (<CheckIcon style={Object.assign({}, notificationStyles.base, notificationStyles.green)} />);
      let activityNotificationText = 'All tenants are active';

      if (props.suspendedTenants) {
        notificationSymbol = (<ReportProblemIcon style={notificationStyles.base} className={'warning'} />);
        activityNotificationText = `${props.suspendedTenants} ${pluralize('tenant', props.suspendedTenants)} are not activated`;
      }

      return (
        <div style={styles.rowStyle}>
          {notificationSymbol}
          <div style={styles.columnStyle}>
            <div className="hint">{activityNotificationText}</div>
          </div>
        </div>
      );
    }
  };

  const main = () => {
    return {
      header: `Total ${pluralize('tenant', props.totalTenants)}`,
      counter: props.totalTenants      
    };
  }

  return (
    <div>
      <h4 className="dashboard-header">
        <span>Tenants</span>
      </h4>
      <div style={Object.assign({ marginBottom: '8px', marginTop: '50px' }, props.styles)}>
        <BaseWidget header={header()} main={main()} 
          onClick={() => props.clickHandle({ route: 'system-admin/tenant-management'})}
        />
      </div>
      <div style={Object.assign({ marginBottom: '30px'}, props.styles)}>
        {
          props.tenantList.map((item, idx) => {
            const count = props.tenantDeviceCountMap[item.name] || 0;
            return (
              <BaseWidget key={idx} header={item.name} 
                main={{ header: `Total ${pluralize('device', count)}`, counter: count }} 
                onClick={() => props.clickHandle({ route: 'system-admin/tenant-management'})}
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default React.memo(TenantsDetails);
